/** Группа тостов нового дизайна чата (флаг chatNewDesign) */
export const CHATMESSAGE_TOAST_GROUP = 'chatmessage';

/** Время показа тоста о новом сообщении */
export const CHATMESSAGE_TOAST_LIFE = 6000;

export type ChatmessageToastData =
  | {
      kind: 'message';
      threadId: number;
      threadTitle: string;
      author: string;
      text: string;
    }
  | {
      kind: 'summary';
      messages: number;
      chats: number;
    };
